import React from 'react';
import { motion } from 'framer-motion';
import { GuaranteeSeal } from './graphics/Graphics';
export function Guarantee() {
  return <section className="bg-cream py-12 md:py-20 px-5" data-id="element-347">
      <div className="max-w-[780px] mx-auto" data-id="element-348">
        <div className="flex flex-col md:flex-row items-center gap-10 md:gap-16" data-id="element-349">
          {/* Left: Badge */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="w-full md:w-auto flex justify-center shrink-0" data-id="element-350">
            <GuaranteeSeal className="w-[160px] h-[160px] md:w-[200px] md:h-[200px] drop-shadow-md" data-id="element-351" />
          </motion.div>

          {/* Right: Copy */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="w-full text-center md:text-left" data-id="element-352">
            <h2 className="font-playfair text-[24px] md:text-[28px] text-ink font-semibold mb-5" data-id="element-353">
              Our Guarantee Is Longer Than Anyone Else's. Here's Why.
            </h2>
            <div className="font-inter text-[16px] text-ink leading-relaxed space-y-4" data-id="element-354">
              <p data-id="element-355">
                Most companies offer a 30-day guarantee. But we know that while
                many women see results in the first week, true nerve-pathway
                restoration takes time. We want you to experience the full
                benefit without rushing.
              </p>
              <p className="font-bold text-forest" data-id="element-356">
                Ninety days gives you the full course with zero financial risk.
              </p>
              <p data-id="element-357">
                If you use DryControl for 90 days and do not feel it has
                significantly improved your quality of life, simply email us. We
                will refund your entire order, including any used patches. You
                don't even need to send the empty boxes back.
              </p>
              <p className="font-inter text-[15px] text-secondary italic mt-6" data-id="element-358">
                This is not marketing language. It is our policy, in writing,
                for every order.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}